import { useCallback, useEffect, useState } from "react";
import Switch from "@material-ui/core/Switch";
// @material-ui/lab components
import { Skeleton } from "@material-ui/lab";

const ToggleCell = ({
  initialValue,
  handleChange,
  initialLoading,
  field,
  disabled,
  remote
}) => {
  const [loading, setLoading] = useState(initialLoading);
  const [value, setValue] = useState(initialValue);

  const handleClick = useCallback(async () => {
    const newValue = !value;

    setLoading(true);

    await handleChange({ [field]: newValue });

    if (!remote) {
      setValue(newValue);
    }
    
    setLoading(false);
  }, [value, handleChange, field, remote]);

  useEffect(() => {
    setLoading(initialLoading);
  }, [initialLoading]);

  return loading ? (
    <Skeleton variant="text" />
  ) : (
    <Switch checked={value} onClick={handleClick} disabled={disabled} />
  );
};

ToggleCell.defaultProps = {
  initialLoading: false,
};

export default ToggleCell;
